/**
 * Normalizes GET /api/admin-dash/board-training/ (placeholder catalog).
 * Contract: { stats: { completed_modules, total_modules, hours_logged, certificates_earned }, modules: [], courses: [] }
 * Older shapes still supported for backwards compatibility.
 */
export function normalizeBoardTraining(raw) {
  const root = raw?.data ?? raw?.results ?? raw;
  if (root == null) return emptyState();

  if (Array.isArray(root)) {
    return {
      stats: {},
      modules: root,
      courses: [],
    };
  }

  const stats = root.stats ?? root.summary ?? {};

  const modules =
    root.modules ??
    root.completed ??
    root.completed_training ??
    root.records ??
    [];
  const courses = root.courses ?? root.upcoming ?? root.scheduled ?? [];

  return {
    stats: {
      completed_modules:
        stats.completed_modules ??
        stats.training_sessions ??
        stats.sessions ??
        null,
      total_modules: stats.total_modules ?? stats.session_count ?? null,
      hours_logged: stats.hours_logged ?? stats.hours ?? null,
      certificates_earned:
        stats.certificates_earned ??
        stats.certifications ??
        stats.cert_count ??
        null,
      participation_rate: stats.participation_rate ?? stats.participation_pct ?? null,
      avg_competency: stats.avg_competency ?? stats.average_competency ?? null,
    },
    modules: Array.isArray(modules) ? modules : [],
    courses: Array.isArray(courses) ? courses : [],
    competencies: Array.isArray(root.competencies ?? root.competency_areas)
      ? root.competencies ?? root.competency_areas
      : [],
  };
}

function emptyState() {
  return {
    stats: {},
    modules: [],
    courses: [],
    competencies: [],
  };
}

export function mapModuleOrCourseRow(item, index) {
  const participants = item.participants ?? item.participant_names ?? item.attendees ?? [];
  const date = item.date ?? item.completed_at ?? item.held_on ?? item.start_date ?? item.due_date;
  return {
    id: item.id ?? index,
    title: item.title ?? item.name ?? item.label ?? "Item",
    date: date ? String(date).slice(0, 10) : "",
    participants: Array.isArray(participants) ? participants : [],
    type: item.type ?? item.format ?? "Module",
    provider: item.provider ?? item.organizer ?? "",
    description: item.description ?? "",
  };
}

export function mapCompetencyRow(item) {
  return {
    area: item.area ?? item.name ?? item.skill ?? "",
    level: typeof item.level === "number" ? item.level : Number(item.score) || 0,
    trend: item.trend ?? "stable",
  };
}
